<template>
  <div>
    <!-- HERO -->
    <div class="hero">
      <!-- <v-img
      :src="isSPSize
        ? require('@/assets/images/img-sp-top-main.png')
        : require('@/assets/images/img-top-main.png')"
      contain/>
      <hgroup class="hero-text">
        <h1 class="primary--text font-weight-bold ff-qs" :class="isSPSize ? 'fz30' : 'fz60'">
          Let’s paike out!
        </h1>
        <h2 class="font-weight-bold" :class="isSPSize ? 'font-h3-sp' : 'font-h1-pc'">
          「好き」は共通言語、<br>
          外国人と「好き」を一緒に楽しもう。
        </h2>
      </hgroup> -->
      <video preload="metadata" autoplay loop muted playsinline>
        <source src="/thumbnails/promo.mp4" type="video/mp4" />
      </video>
    </div>

    <!-- Action Buttons -->
    <v-container class="action-buttons ma-0">
      <v-row justify="center">
        <!--
        <v-col cols="12" sm="3">
          <v-btn
            dark
            block
            rounded
            depressed
            outlined
            :height="isSPSize ? 52 : 68"
            class="primary--text"
            @click="goToLocal">
            <div class="d-flex flex-column">
              <span class="fz18 font-weight-bold">ローカルの方</span>
              <span class="fz15 font-weight-bold">{{'for locals'.toLowerCase()}}</span>
            </div>
          </v-btn>
        </v-col>
        <v-col cols="12" sm="3">
          <v-btn
            light
            block
            rounded
            depressed
            outlined
            :height="isSPSize ? 52 : 68"
            class="primary--text"
            @click="goToTraveler">
            <div class="d-flex flex-column">
              <span class="fz18 font-weight-bold">旅行する方</span><span class="fz15 font-weight-bold">for travelers</span>
            </div>
          </v-btn>
        </v-col>
        -->
        <v-col cols="12" sm="6" md="3" class="text-center fz17 mb-4">
          <span class="font-weight-bold d-block mb-6">アプリではじめよう！</span>
          <v-row class="d-flex align-center justify-center mb-4">
              <a class="apple" href="https://apps.apple.com/jp/app/paike-passion-like/id1539421003">
                <img class="d-block" src="@/assets/images/Download_on_the_App_Store_Badge.svg" alt="">
              </a>
              <a class="google" href="https://play.google.com/store/apps/details?id=com.paikeout.app">
                <img class="d-block" src="@/assets/images/google-play-badge.png" alt="">
              </a>
          </v-row>
          <span class="fz17">or</span>
          <v-btn
            block
            depressed
            color="primary"
            height="40"
            style="text-transform:none !important"
            class="font-weight-bold btn mt-4 py-2"
            @click="goToBoth"
          >
            Sign Up
          </v-btn>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col cols="12">
          <p class="font-xs text-center">現在β（ベータ）版のため、機能や地域を限定してご利用いただけます。</p>
        </v-col>
      </v-row>
    </v-container>

    <v-container :class="isSPSize ? 'sp' : ''">
      <v-row justify="center">
        <v-col cols="12" class="text-center">
          <h2 class="font-h1-pc" :class="isSPSize ? 'mb30' : 'mb40'">
            What is Paike?
          </h2>
          <p>
            Paike（パイク）は、<br>
            “Passion” ✕“Like”から生まれた、<br>
            これからの旅を変えるキーワード。
          </p>
          <v-img
            :src="require('@/assets/images/img-01.png')"
            class="mt-3 mb-5 d-inline-block"
            contain
            :max-width="isSPSize ? '' : '500px'"
          ></v-img>
          <p>
            今は旅に行けません。<br>しかし、この状況でも自宅から、自分の「好き」で世界とつながることができます。
          </p>
        </v-col>
      </v-row>
    </v-container>

    <v-container :class="isSPSize ? 'sp' : ''" class="features">
      <v-row justify="center">
        <v-col cols="12" class="text-center">
          <h2 class="font-h1-pc" :class="isSPSize ? 'mb30' : 'mb40'">
            Paikeの３つの特徴
          </h2>
          <p>
            いつの日か旅に出るまでに旅先に友達（Paiker）をつくりましょう！
          </p>
        </v-col>
      </v-row>
      <v-row justify="center" class="text-center">
        <v-col cols="12" sm="6">
          <div class="features-group">
            <h3 class="fz18 font-weight-bold">
              ローカルの方
            </h3>
            <div class="features-item">
              <v-img
                :src="require('@/assets/images/local01.png')"
                class="my-3"
                contain
                height="150"
              ></v-img>
              <h4 class="fz18">
                流暢な英語は必要なし
              </h4>
              <p class="fz15">
                「好き」は共通言語、<br>ブロークン・イングリッシュでOK！
              </p>
              <v-img
                :src="require('@/assets/images/local02.png')"
                class="my-3"
                contain
                height="150"
              ></v-img>
              <h4 class="fz18">
                楽しみながら国際交流
              </h4>
              <p class="fz15">
                同じ「好き」を通して、<br>楽しくコミュニケーション！
              </p>
              <v-img
                :src="require('@/assets/images/local03.png')"
                class="my-3"
                contain
                height="150"
              ></v-img>
              <h4 class="fz18">
                利用料金は無料
              </h4>
              <p class="fz15">
                無料だからこその気軽さ！
              </p>
            </div>
          </div>
        </v-col>
        <v-col cols="12" sm="6">
          <div class="features-group">
            <h3 class="fz18 font-weight-bold">
              旅行する方
            </h3>
            <div class="features-item">
              <v-img
                :src="require('@/assets/images/img-02.png')"
                class="my-3"
                contain
                height="150"
              ></v-img>
              <h4 class="fz18">
                ローカルと一緒に特別な体験
              </h4>
              <p class="fz15">
                ローカルとガイドブックにはない特別な体験を。<br>
                あなたの「好き」をローカルと一緒に楽しもう！
              </p>
              <v-img
                :src="require('@/assets/images/img-03.png')"
                class="my-3"
                contain
                height="150"
              ></v-img>
              <h4 class="fz18">
                新たな「好き」を発見
              </h4>
              <p class="fz15">
                「好き」が一緒のローカルと触れ合い、<br>
                新たな世界を開拓しよう！
              </p>
              <v-img
                :src="require('@/assets/images/img-04.png')"
                class="my-3"
                contain
                height="150"
              ></v-img>
              <h4 class="fz18">
                利用料金は無料
              </h4>
              <p class="fz15">
                Paikeは、ツアーガイドではなく、<br class="d-sm-none">友達を探す場所！
              </p>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>

    <!-- Paike の使い方 -->
    <!--
    <v-container :class="isSPSize ? 'sp' : ''" class="usage">
      <v-row justify="center">
        <v-col cols="12" class="text-center">
          <h2 class="font-h1-pc" :class="isSPSize ? 'mb30' : 'mb40'">
            Paikeの使い方
          </h2>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" offset-sm="3" v-for="(usage, index) in usageList" :key="index">
          <div class="usage-item d-flex align-start">
            <div class="image align-center">
              <v-img
                :src="usage.src"
                class="my-3"
                contain
                height="80"
              ></v-img>
            </div>
            <div class="text">
              <p class="fz18 font-weight-bold" v-html="usage.title"/>
              <p class="fz15" v-html="usage.text"/>
              <p v-if="usage.notice" class="notice" v-html="usage.notice"/>
              <span class="arrow" v-if="index !== usageList.length -1">
                <v-img
                  :src="require('@/assets/images/arrow-step-down.svg')"
                  contain
                  height="23"
                ></v-img>
              </span>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
    -->

    <!-- Action Buttons -->
    <v-container class="action-buttons ma-0">
      <!-- <v-row justify="center">
        <p class="ff-qs font-h1-pc primary--text font-weight-bold">Let’s paike out!</p>
      </v-row> -->
      <v-row justify="center">
        <!--
        <v-col cols="12" sm="3">
          <v-btn
            dark
            block
            rounded
            depressed
            outlined
            height="68"
            class="primary--text"
            @click="goToLocal">
            <div class="d-flex flex-column">
              <span class="fz18 font-weight-bold">ローカルの方</span>
              <span class="fz15 font-weight-bold">{{'for locals'.toLowerCase()}}</span>
            </div>
          </v-btn>
        </v-col>
        <v-col cols="12" sm="3">
          <v-btn
            light
            block
            rounded
            depressed
            outlined
            height="68"
            class="primary--text"
            @click="goToTraveler">
            <div class="d-flex flex-column">
              <span class="fz18 font-weight-bold">旅行する方</span><span class="fz15 font-weight-bold">for travelers</span>
            </div>
          </v-btn>
        </v-col>
        -->
        <v-col cols="12" sm="6" md="3" class="text-center fz17 mb-4">
          <span class="font-weight-bold d-block mb-6">アプリではじめよう！</span>
          <v-row class="d-flex align-center justify-center mb-4">
              <a class="apple" href="https://apps.apple.com/jp/app/paike-passion-like/id1539421003">
                <img class="d-block" src="@/assets/images/Download_on_the_App_Store_Badge.svg" alt="">
              </a>
              <a class="google" href="https://play.google.com/store/apps/details?id=com.paikeout.app">
                <img class="d-block" src="@/assets/images/google-play-badge.png" alt="">
              </a>
          </v-row>
          <span class="fz17">or</span>
          <v-btn
            block
            depressed
            color="primary"
            height="40"
            style="text-transform:none !important"
            class="font-weight-bold btn mt-4 py-2"
            @click="goToBoth"
          >
            Sign Up
          </v-btn>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col cols="12" class="pb-0">
          <p class="font-xs text-center mb-0">現在β（ベータ）版のため、機能や地域を限定してご利用いただけます。</p>
        </v-col>
      </v-row>
    </v-container>

    <!--
    <v-container :class="isSPSize ? 'sp' : ''" class="video">
      <v-row justify="center">
        <v-col cols="12" class="text-center">
          <h2 class="font-h1-pc" :class="isSPSize ? 'mb30' : 'mb40'">
            Paiker’s Video
          </h2>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col
          cols="12"
          sm="4"
          v-for="(video, index) in videoList"
          :key="index"
        >
          <pikers-video :video="video"/>
        </v-col>
      </v-row>
    </v-container>
    -->

    <v-container :class="isSPSize ? 'sp' : ''" class="voice">
      <v-row justify="center">
        <v-col cols="12" class="text-center">
          <h2 class="font-h1-pc" :class="isSPSize ? 'mb30' : 'mb40'">
            Paiker’s Voice
          </h2>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col
          cols="12"
          sm="4"
          v-for="(voice, index) in voiceList"
          :key="index"
        >
          <pikers-voice :voice="voice"/>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import PikersVoice from '@/components/PikersVoice'
import service from '@/plugins/service'

export default {
  components: {
    PikersVoice,
  },
  computed: {
    h1Style() {
      return this.isSPSize
        ? 'font-h1-sp font-weight-bold mb-3'
        : 'font-h1-pc font-weight-bold mb-5'
    },
    isSPSize() {
      return this.$vuetify.breakpoint.name === 'xs'
    },
  },
  data: () => ({
    usageList: [
    {
        src: require('@/assets/images/img-register.png'),
        title: '1.登録',
        text: 'まずはメールアドレスと自分の「好き」を登録。'
      },
      {
        src: require('@/assets/images/matching.png'),
        title: '2.マッチング',
        text: 'Paikeがあなたと同じ「好き」を持った外国人をマッチング。',
        notice: 'Paikeがあなたに最適の相手を探します。'
      },
      {
        src: require('@/assets/images/pickatime.png'),
        title: '3.日程を決定',
        text: 'マッチした外国人と具体的な日程や詳細を決定。',
        notice: '決定まで、Paikeがあなたをサポートします。'
      },
      {
        src: require('@/assets/images/havefun.png'),
        title: '4.「好き」を楽しもう',
        text: '外国人と待ち合わせをして、一緒に「好き」を楽しもう。'
      },
    ],
    videoList: [
      {
        genre: '野球観戦',
        src: '<iframe width="100%" height="auto" src="https://www.youtube.com/embed/KTCzGW4cWYg" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>',
        location: '明治神宮球場',
      },
      {
        genre: 'スイーツ',
        src: '<iframe width="100%" height="auto" src="https://www.youtube.com/embed/qANt52x_SdM" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>',
        location: '麻布十番',
      },
      {
        genre: 'カラオケ',
        src: '<iframe width="100%" height="auto" src="https://www.youtube.com/embed/YLwn4FQqce4" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>',
        location: '赤坂見附',
      },
    ],
    voiceList: [
      {
        title: 'お好み焼き',
        src: require('@/assets/images/img-voice01.png'),
        like: 'お好み焼き',
        location: '月島',
        text: '英語だと、何を話していいかなど考えてしまい、会話がなかなか続かなかったり、口数が少なくなってしまいます。<br>ただ、好きなものが同じだと、「アメリカで食べたお好み焼きはこうで、全然違うよ」「値段が全然ちがう」「広島風と大阪風では～」といったように会話がしやすく、気づかないうちに盛り上がっていました。<br>もちろん、うまく話せれなかったり、聞き取れなかったりしますが、そんなこと気にせず、楽しめました！<br>特に、お好み焼きは、作りながら話すので、会話が盛り上がりやすいと思います。あと、もんじゃ焼きに感激してもらいました。<br>日本人には当たり前のことでも、こうやって、外国人の人に楽しんでもらえると、日本人として本当にうれしいです。'
      },
      {
        title: 'カラオケ',
        src: require('@/assets/images/img-voice02.png'),
        like: 'カラオケ',
        location: '赤坂見附',
        text: 'Paikeで初めて会った外国人の方と一緒にカラオケに行きました！英語が得意というわけじゃなくても、世界中で流行っている歌を一緒に歌ったりして、想像以上に楽しかったです！<br>もちろん英語が通じないこと、聞き取れないこともありましたが、盛り上がるうちに楽しめました♪<br>もともと旅行が大好きなので海外旅行にはよく行っていますが、日本にいながらも手軽に国際交流ができるのは嬉しいです。<br>カラオケにまつわる英会話も教えてもらえたりしたので、別の趣味のヨガやショッピングでもPaikeを使用してみたいです！'
      },
    ]
  }),
  methods: {
    ...mapActions('storage', [
      'setLastRoute',
      'setTopButtonLocal',
      'setTopButtonTraveler',
    ]),
    goToTraveler() {
      this.setTopButtonTraveler()
      this.goTo('/onBoarding/t1')
    },
    goToLocal() {
      this.setTopButtonLocal()
      this.goTo('/onBoarding/l1')
    },
    goToBoth() {
      this.setTopButtonTraveler()
      this.goTo('/onBoarding/b1')
    },
    goTo(route) {
      this.setLastRoute('Top')
      service.authCheck().then(() => {
        this.$router.push('/likes')
      }).catch(() => {
        this.$router.push(route)
      })
    },
  }
};
</script>

<style lang="scss" scoped>
  @import '@/sass/variables.scss';
  @import '~vuetify/src/styles/styles.sass';

  .apple {
    img {
      width: 100%;
      max-height: 40px;
    }
    margin-right: 6px;
  }
  .google {
    margin-left: 6px;
    img {
      height: 40px;
    }
  }
  .btn {
    font-size: $btn-font-size-smaller !important;
    letter-spacing: $btn-letter-spacing;
  }
</style>

<style lang="stylus" scoped>
@import '../../assets/stylus/_variables'
.hero
  display block
  background #FFD5BF
  @media only screen and (min-width: 600px)
    display flex
    justify-content center
  video
    width 100%
    background #FFD5BF
    display block
    @media only screen and (min-width: 600px)
      width 600px

.action-buttons
  padding 40px 0
  background $color-lightOrange
  max-width unset !important
  @media screen and (max-width: 600px)
    padding 30px 35px
  .v-btn
    border-width 2px !important
    border-radius 8px !important
    background white

.features
  &-group
    border 2px solid $color-lightGray

    h3
      padding 20px 0
      background $color-lightOrange

.usage
  &-item
    .image
      margin-right 40px
      min-width 80px
    .text
      width 100%
      text-align left
    .notice
      background $color-lightOrange
      padding 20px

</style>